<template>
  <div>
    <EplNewBackHeader v-if="$route.name!=='Dashboard'" />
    <slot />
  </div>
</template>
<script>
import EplNewBackHeader from "../components/EplNewBackHeader/index";
export default {
  name: "EplNewLayout",
  components: {
    EplNewBackHeader
  }
};
</script>



// WEBPACK FOOTER //
// src/layouts/EplNew.vue